import {
  AppWrapper,
  ButtonWrapper,
  PageContainer,
  PageWrapper,
  PrimaryButton,
  PrimaryButtonLink,
  SecondaryButtonLink,
  PageSection,
  ParagraphText,
  DisplayTableWrapper,
  TableBody,
  DisplayTableRow,
  DisplayTableCell,
  SecondaryButton,
  Input,
  ValidationText
} from "./UIKit/styles";

import {
  EmailLinkModal,
  ErrorModal,
  Header,
  LoadingModal,
  NavBar,
  UnavailableViewModal,
  Footer,
  SaveMessage,
  SummaryModal,
} from "./Components";

import {
  FormInput
} from "./UIKit/components"


import { useNavigate } from "react-router";
import { Routes, Route, useLocation, useRoutes } from "react-router-dom";
import {
  COMPLETED_VIEWS_KEY,
  INPUT_DATA_KEY,
  NAV_LINKS,
  NEXT_PAGE_TEXT,
  OPEN_EMAIL_BUTTON_TEXT,
  PREV_PAGE_TEXT,
  RESULTS_KEY,
  RESULTS_TEXT,
  VIEWS,
  WHAT_IF_VIEW,
  WHAT_IF_TEXT,
  DISCLAIMER_VIEW,
  ORCHARD_DATA_KEY,
  EMISSION_FIELDS,
  CLONE_STATUS_INITIALISE,
  CLONE_STATUS_CLONING,
  CLONE_STATUS_SUCCESS,
  PRINT_BUTTON_TEXT,
  CLONE_RESULTS_BUTTON_TEXT,
  CLONE_RESULTS_SUCCESS_TITLE,
  CLONE_RESULTS_SUCCESS_TEXT,
  CLONE_RESULTS_TITLE,
  CLONE_RESULT_SUCCESS_TITLE,
  DELETE_STATUS_DELETING,
  DELETE_STATUS_INITIALISE,
  DELETE_RESULTS_TEXT,
  DELETE_RESULTS_TITLE,
  DELETE_RESULTS_BUTTON_TEXT,
  DELETE_STATUS_SUCCESS,
  DELETE_RESULTS_SUCCESS_TITLE,
  CLOSE_MODAL_TEXT,
  CANCEL_MODDAL_TEXT,
  DELETE_STATUS_ERROR,
  CALCULATION_STATUS_COMPLETED,
  CALCULATION_STATUS_DRAFT,
  CALCULATION_SAVE_TIMER_DURATION,
  FINAL_VALUES,
  NON_SAVING_URLS,
  CALCULATED_RESULTS_KEY,
  VALIDATION_MESSAGE_REQUIRED
} from "./constants";

import {
  Calculator,
  Results,
  NotFound,
  WhatIf,
  Disclaimer,
  Summary,
} from "./Views";
import { useEffect, useState } from "react";
import {
  convertToPercentages,
  getCurrentViewIndex,
  getIsViewDisabled,
  getSessionStorageValue,
  getViewFieldsIncomplete,
  isNullOrUndefined,
  setSessionStorage,
  setViewAsCompleted,
  formatNumber,
} from "./utils/utils";

import { Loader } from "./UIKit/components";
import { getCurrentUser, fetchUserAttributes } from "aws-amplify/auth";

function App({ user, signOut, getUserBearerToken, setShowDisclaimer }) {
  const navigate = useNavigate();

  const { pathname, search } = useLocation();
  //store this at a higher level so that the view renderers when data is updated, for the purposes of allowing the navbar access to the data
  const [data, setData] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);
  const [prevLink, setPrevLink] = useState(null);
  const [nextLink, setNextLink] = useState(null);
  const [currentViewInfo, setCurrentViewInfo] = useState(null);
  const [showResultsButton, setShowResultsButton] = useState(false);
  const [emailModalOpen, setEmailModalOpen] = useState(false);
  const [recalculateResults, setRecalculateResults] = useState(false);
  const [saveMessage, SetSaveMessage] = useState(null);
  const [userDetails, setUserDetails] = useState({
    given_name: "",
    family_name: "",
    email: "",
  });

  const [orchardData, setOrchardData] = useState([]);
  const [renewOrchardData, setRenewOrchardData] = useState(true);
  const [modalOpen, setModalOpen] = useState(false);
  const [selectedOrchard, setselectedOrchard] = useState(null);
  const [modalTitle, setModalTitle] = useState(null);
  const [modalContent, setModalContent] = useState(null);
  const [actionStatus, setActionStatus] = useState(null);
  const [allowClose, setAllowClose] = useState(true);
  const [clonedKpinName, setClonedKpinName] = useState(null);

  useEffect(() => {
    const getActionModalContent = async () => {
      const {
        input: {
          kpin = "",
          season = "",
          calculatorDetails: { orchardName = "" },
        },
      } = selectedOrchard;
      if (!orchardData) return;

      try {
        if (actionStatus === null) {
          return;
        } else if (actionStatus === CLONE_STATUS_CLONING) {
          setAllowClose(false);
          setModalContent(<Loader />);
        } else if (actionStatus === CLONE_STATUS_INITIALISE) {
          setAllowClose(true);
          setModalTitle(CLONE_RESULTS_TITLE);

          setModalContent(
            <>
              <ParagraphText>
                This will clone the inputs of the current selected results.
              </ParagraphText>
              <DisplayTableWrapper>
                <TableBody>
                  <DisplayTableRow>
                    <DisplayTableCell>KPIN:</DisplayTableCell>
                    <DisplayTableCell>
                      <Input
                        type="text"
                        value={clonedKpinName}
                        onChange={(e) => setClonedKpinName(e.target.value)}
                      />

                      <ValidationText>{VALIDATION_MESSAGE_REQUIRED}</ValidationText>

                    </DisplayTableCell>
                  </DisplayTableRow>
                  <DisplayTableRow>
                    <DisplayTableCell>Orchard Name:</DisplayTableCell>
                    <DisplayTableCell>
                      <strong>{orchardName}</strong>
                    </DisplayTableCell>
                  </DisplayTableRow>
                  <DisplayTableRow>
                    <DisplayTableCell>Season:</DisplayTableCell>
                    <DisplayTableCell>
                      <strong>{season}</strong>
                    </DisplayTableCell>
                  </DisplayTableRow>
                </TableBody>
              </DisplayTableWrapper>
              <ButtonWrapper alignButtons="center">
                <PrimaryButton
                  onClick={() => {
                    cloneSelectedResults();
                  }}
                >
                  {CLONE_RESULTS_BUTTON_TEXT}
                </PrimaryButton>
              </ButtonWrapper>
            </>
          );
        } else if (actionStatus === CLONE_STATUS_SUCCESS) {
          setAllowClose(true);
          setModalTitle(CLONE_RESULT_SUCCESS_TITLE);
          setModalContent(
            <>
              <PageSection>
                <ParagraphText>{CLONE_RESULTS_SUCCESS_TEXT}</ParagraphText>
              </PageSection>
              <ButtonWrapper alignButtons="center">
                <PrimaryButton
                  onClick={() => {
                    setModalOpen(false);
                    if (selectedOrchard) {
                      navigate(`../summary`);
                    }
                  }}
                >
                  {CLONE_RESULTS_SUCCESS_TITLE}
                </PrimaryButton>
              </ButtonWrapper>
            </>
          );
        } else if (actionStatus === DELETE_STATUS_DELETING) {
          setAllowClose(false);
          setModalContent(<Loader />);
        } else if (actionStatus === DELETE_STATUS_INITIALISE) {
          setAllowClose(true);
          setModalTitle(DELETE_RESULTS_TITLE);

          setModalContent(
            <>
              <ParagraphText>
                This will permanently delete the inputs and result for the
                following calculation
              </ParagraphText>
              <DisplayTableWrapper>
                <TableBody>
                  <DisplayTableRow>
                    <DisplayTableCell>KPIN:</DisplayTableCell>
                    <DisplayTableCell>
                      <strong>{kpin}</strong>
                    </DisplayTableCell>
                  </DisplayTableRow>
                  <DisplayTableRow>
                    <DisplayTableCell>Orchard Name:</DisplayTableCell>
                    <DisplayTableCell>
                      <strong>{orchardName}</strong>
                    </DisplayTableCell>
                  </DisplayTableRow>
                  <DisplayTableRow>
                    <DisplayTableCell>Season:</DisplayTableCell>
                    <DisplayTableCell>
                      <strong>{season}</strong>
                    </DisplayTableCell>
                  </DisplayTableRow>
                </TableBody>
              </DisplayTableWrapper>
              <ParagraphText>
                Please confirm you want to delete this calculation as this can
                not be undone.
              </ParagraphText>
              <ButtonWrapper alignButtons="center" type="share-bar">
                <PrimaryButton
                  onClick={() => {
                    deleteSelectedResults();
                  }}
                >
                  {DELETE_RESULTS_BUTTON_TEXT}
                </PrimaryButton>
                <SecondaryButton
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  {CANCEL_MODDAL_TEXT}
                </SecondaryButton>
              </ButtonWrapper>
            </>
          );
        } else if (actionStatus === DELETE_STATUS_SUCCESS) {
          setAllowClose(true);
          setModalTitle(DELETE_RESULTS_SUCCESS_TITLE);
          setModalContent(
            <>
              <PageSection>
                <ParagraphText>{DELETE_RESULTS_SUCCESS_TITLE}</ParagraphText>
              </PageSection>
              <ParagraphText>
                The calculation has been deleted. Click close to return to the
                orchard summary page.{" "}
              </ParagraphText>
              <ButtonWrapper alignButtons="center">
                <PrimaryButton
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  {CLOSE_MODAL_TEXT}
                </PrimaryButton>
              </ButtonWrapper>
            </>
          );
        } else if (actionStatus === DELETE_STATUS_ERROR) {
          setAllowClose(true);
          setModalTitle(DELETE_STATUS_ERROR);
          setModalContent(
            <>
              <PageSection>
                <ParagraphText>
                  There was an error in trying to delete the selected
                  calculation. Please try again in at a later date.
                </ParagraphText>
                <ParagraphText>
                  Click close to return to the orchard summary page.{" "}
                </ParagraphText>
              </PageSection>
              <ButtonWrapper alignButtons="center">
                <PrimaryButton
                  onClick={() => {
                    setModalOpen(false);
                  }}
                >
                  {CLOSE_MODAL_TEXT}
                </PrimaryButton>
              </ButtonWrapper>
            </>
          );
        }
      } catch (e) {
        setError(e.message);
      }
    };
    if (!selectedOrchard) return;

    getActionModalContent();
    return () => {
      setError(null);
    };
  }, [actionStatus, clonedKpinName]);

  useEffect(() => {
    setRenewOrchardData(false);
    setLoading(true);
    loadOrchardDataForUser();
    return () => {
      setOrchardData(null);
      setError(null);
    };
  }, []);

  useEffect(() => {
    if (!renewOrchardData) {
      return;
    } else {
      loadOrchardDataForUser();
      setRenewOrchardData(false);
    }
    return () => {
      setLoading(true);
      setError(null);
    };
  }, [renewOrchardData]);

  const loadOrchardDataForUser = async () => {
    try {
      let orchardData = (await getSessionStorageValue(ORCHARD_DATA_KEY)) || [];
      const token = await getUserBearerToken();
      // if (!token) {
      //     navigate(`../login`)
      // }

      let inputData = getSessionStorageValue(INPUT_DATA_KEY) || {
        calculatorDetails: {},
        varieties: {
          green: {},
          gold: {},
          other: {},
        },
      };

      setLoading(true);
      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/v2/user`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );
      const { error, items } = await response.json();
      if (error) throw new Error(error);
      orchardData = items;

      orchardData = orchardData.map((orchard) => {
        if (!orchard.result) return orchard;
        const totalPerHa = EMISSION_FIELDS.reduce((result, key) => {
          return key.includes("nitrogen") || key.includes("total")
            ? result
            : result + orchard.result.results.totalPerHa[key];
        }, 0);

        orchard.result.results.total.totalPerHa = formatNumber(
          Math.round(totalPerHa)
        );

        if (orchard.result.results.greenEmissionsPerHa) {
          const totalGreenPerHa = EMISSION_FIELDS.reduce((result, key) => {
            return key.includes("nitrogen") || key.includes("total")
              ? result
              : result + orchard.result.results.greenEmissionsPerHa[key];
          }, 0);
          orchard.result.results.total.totalGreenPerHa = formatNumber(
            Math.round(totalGreenPerHa)
          );
        }

        if (orchard.result.results.goldEmissionsPerHa) {
          const totalGoldPerHa = EMISSION_FIELDS.reduce((result, key) => {
            return key.includes("nitrogen") || key.includes("total")
              ? result
              : result + orchard.result.results.goldEmissionsPerHa[key];
          }, 0);
          orchard.result.results.total.totalGoldPerHa = formatNumber(
            Math.round(totalGoldPerHa)
          );
        }

        return orchard;
      });

      setData(inputData);
      setOrchardData(orchardData);
      setSessionStorage(ORCHARD_DATA_KEY, orchardData);
      setRenewOrchardData(false);
    } catch (e) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  };

  //on mount, check for session storage values, and if these are set, put these in state
  useEffect(() => {
    const setInitialData = async () => {
      try {
        const searchParams = new URLSearchParams(search || "");
        const shareId = searchParams.get("shareId");
        const kpin = searchParams.get("kpin");
        if (shareId && kpin) {
          await getResultsData(shareId, kpin);
          setRecalculateResults(false);
        }
      } catch (e) {
        setError(e.message);
      } finally {
        setLoading(false);
      }
    };
    setInitialData();
    return () => {
      setData(null);
      setLoading(true);
      setError(null);
      setEmailModalOpen(false);
    };
  }, []);

  //when router changes, set the next and prev button links. Also set the current view settings in state
  useEffect(() => {
    const updateButtonLinks = () => {
      let nextNavLink, prevNavLink, shouldShowResultsButton;
      const path = pathname.replace("/", "");
      const currentIndex = getCurrentViewIndex(pathname);
      if (!isNullOrUndefined(currentIndex)) {
        nextNavLink =
          path !== VIEWS[VIEWS.length - 1].path
            ? NAV_LINKS[currentIndex + 1]
            : null;
        prevNavLink = NAV_LINKS[currentIndex - 1];
        shouldShowResultsButton =
          (path !== NAV_LINKS[NAV_LINKS.length - 1].path &&
            getSessionStorageValue(RESULTS_KEY)) ||
          path === VIEWS[VIEWS.length - 1].path;
      }

      setPrevLink(prevNavLink ? `../${prevNavLink.path}${search}` : null);
      setNextLink(nextNavLink ? `../${nextNavLink.path}${search}` : null);

      setCurrentViewInfo(NAV_LINKS[currentIndex]);

      setShowResultsButton(shouldShowResultsButton);
    };
    updateButtonLinks();
    return () => {
      setPrevLink(null);
      setNextLink(null);
    };
  }, [pathname, search]);

  useEffect(() => {
    if (recalculateResults) setRecalculateResults(false);
  }, [search]);

  useEffect(() => {
    const hideDisclaimer = () => {
      setShowDisclaimer(false);
    };
    hideDisclaimer();
  }, []);

  //when current view info changes, check if any fields are invalid. If not, set the view as 'completed' so that the next nav link and next butt become enabled
  useEffect(() => {
    const checkIfSectionCompleted = () => {
      if (!currentViewInfo) return;
      if (!getViewFieldsIncomplete(currentViewInfo, data))
        setViewAsCompleted(pathname);
    };
    checkIfSectionCompleted();
  }, [currentViewInfo]);

  //when data changes in state, sync this with session storage
  useEffect(() => {
    const syncSessionStorage = () => {
      if (!data) return;
      //set to recalculate results if none are in session storage OR any values have changed
      const shouldRecalculateResults =
        !(search && !getSessionStorageValue(INPUT_DATA_KEY)) &&
        JSON.stringify(data) !==
          JSON.stringify(getSessionStorageValue(INPUT_DATA_KEY));

      setSessionStorage(INPUT_DATA_KEY, data);
      setRecalculateResults(shouldRecalculateResults);
      // const url = new URL(window.location.href);

      // if (
      //   shouldRecalculateResults === true &&
      //   !NON_SAVING_URLS.includes(url.pathname)
      // ) {
      //   if (saveTimer) {
      //     clearTimeout(saveTimer);
      //   }
      //   const windowTimer = setTimeout(() => {
      //     saveProgressTimer();
      //   }, CALCULATION_SAVE_TIMER_DURATION);
      //   setSaveTimer(windowTimer);
      // }
      const viewInfo = VIEWS.find(
        (view) => view.path === pathname.replace("/", "")
      );
      //if the current view has all fields completed now, set view as complete to enable next button and next nav link
      if (viewInfo && !getViewFieldsIncomplete(viewInfo, data))
        setViewAsCompleted(pathname);

      //Update Save message
    };

    syncSessionStorage();
  }, [data]);

  //get signed in user
  useEffect(() => {
    const getUserDetails = async () => {
      try {
        const user = await fetchUserAttributes();

        if (user) {
          const { given_name, family_name, email } = user;
          setUserDetails({ given_name, family_name, email });
        }
      } catch (err) {
        console.log(err);
      }
    };

    getUserDetails();
  }, []);

  //Gets and sets results data from Storage or API if not present

  const getResultsData = async (shareId, kpin) => {
    try {
      let inputData = getSessionStorageValue(INPUT_DATA_KEY) || {
        calculatorDetails: {},
        varieties: {
          green: {},
          gold: {},
          other: {},
        },
      };

      let orchardData = (await getSessionStorageValue(ORCHARD_DATA_KEY)) || [];

      const orchard = orchardData.find(
        (orchard) => orchard.input?.shareId === shareId
      );

      let calculatedResults = null;
      let calculatorInputs = null;
      let calculatorVarities = null;

      if (orchard) {
        const { result, input } = orchard;
        calculatedResults = result;
        calculatorInputs = input.calculatorDetails;
        calculatorVarities = input.varieties;
      } else {
        const token = await getUserBearerToken();
        const response = await fetch(
          `${process.env.REACT_APP_CALC_API_URL}/v2/kpins/${kpin}/shares/${shareId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        const { error, results, inputs } = await response.json();
        if (error) throw new Error(error);
        calculatedResults = results;
        calculatorInputs = inputs.calculatorDetails;
        calculatorVarities = inputs.varieties;
      }

      inputData = {
        calculatorDetails: convertToPercentages(calculatorInputs),
        varieties: Object.keys(calculatorVarities).reduce((result, key) => {
          return {
            ...result,
            [key]: convertToPercentages(calculatorVarities[key]),
          };
        }, {}),
      };

      setSessionStorage(COMPLETED_VIEWS_KEY, [
        "",
        ...NAV_LINKS.map(({ path }) => path),
      ]);
      setSessionStorage(RESULTS_KEY, calculatedResults);
      setData(inputData);
    } catch (e) {
      setError(e.message);
    }
  };

  //return the nav links, with a 'disabled' state
  const getNavLinks = () => {
    return NAV_LINKS.reduce((result, view, i) => {
      const { path, title, includeInNav } = view;
      if (includeInNav === false) return result;
      let disabled = getIsViewDisabled(path);
      //don't disable the current view
      if (path === pathname.replace("/", "")) disabled = false;
      //if is the nav link immediately after the current active link, enable this if the current view is completed
      else if (
        i === getCurrentViewIndex(pathname) + 1 &&
        !getViewFieldsIncomplete(NAV_LINKS[i - 1], data)
      ) {
        disabled = false;
      }
      return [
        ...result,
        {
          path: path !== "summary" && path !== "/" ? `${path}${search}` : path,
          title,
          disabled,
          renewOrchardData: path === "summary" ? true : false,
          setRenewOrchardData
        },
      ];
    }, []);
  };

  //return true if any fields are not completed
  const getNextButtonDisabled = () => {
    const currentIndex = getCurrentViewIndex(pathname);
    if (currentIndex < 0) return false;
    return getViewFieldsIncomplete(NAV_LINKS[currentIndex], data);
  };

  //return the 'results' text if is the last form input view
  //return the 'i agree' text if is the disclaimer view
  //else return 'next page' text
  const getNextButtonText = () => {
    if (!currentViewInfo || !currentViewInfo.nextButtonText)
      return NEXT_PAGE_TEXT;
    return currentViewInfo.nextButtonText;
  };

  const initialiseCalculation = () => {
    // setViewAsCompleted("/");
    // setViewAsCompleted("/summary");
    setSessionStorage(COMPLETED_VIEWS_KEY, [...new Set(["/", "summary"])]);
    setSessionStorage(CALCULATED_RESULTS_KEY, null);

    const inputData = {
      calculatorDetails: {
        ...FINAL_VALUES.calculatorDetails,
        shareName: `${userDetails.given_name} ${userDetails.family_name}`,
        email: userDetails.email,
      },
      varieties: FINAL_VALUES.varieties,
    };
    setSessionStorage(RESULTS_KEY, null);
    setData(inputData);
  };

  const cloneSelectedResults = async () => {
    setActionStatus(CLONE_STATUS_CLONING);
    try {
      const inputData = {
        ...selectedOrchard.input,
        kpin: clonedKpinName,
        calculatorDetails: convertToPercentages(
          selectedOrchard.input.calculatorDetails
        ),
        varieties: Object.keys(selectedOrchard.input.varieties).reduce(
          (result, key) => {
            return {
              ...result,
              [key]: convertToPercentages(selectedOrchard.input.varieties[key]),
            };
          },
          {}
        ),
      };



      setData(inputData);

      const token = await getUserBearerToken();
      const { calculatorDetails, varieties } = selectedOrchard.input;

      calculatorDetails.kpin = clonedKpinName;

      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/v2/kpins/${clonedKpinName}?saveDraft=true`,
        {
          headers: { Authorization: `Bearer ${token}` },
          method: "POST",
          body: JSON.stringify({
            calculatorDetails,
            varieties,
          }),
        }
      );

      const { shareId } = await response.json();
      if (!shareId) throw new Error(error);
      loadOrchardDataForUser();
      SetSaveMessage(
        `Draft last saved  ${new Date().toLocaleDateString()}  ${new Date().toLocaleTimeString()}`
      );

      setViewAsCompleted("/");
      setViewAsCompleted("/summary");

      setSessionStorage(RESULTS_KEY, selectedOrchard.result);
      setActionStatus(CLONE_STATUS_SUCCESS);
    } catch (e) {
      setError(e.message);
    }
  };

  const resumeDraft = async (orchard) => {
    try {
      setViewAsCompleted("/");
      setViewAsCompleted("/summary");

      const { input } = orchard;

      const inputData = {
        ...input,
        calculatorDetails: convertToPercentages(input.calculatorDetails),
        varieties: Object.keys(input.varieties).reduce((result, key) => {
          return {
            ...result,
            [key]: convertToPercentages(input.varieties[key]),
          };
        }, {}),
      };
      await setData(inputData);
      navigate(
        `../orchard-overview?shareId=${input.shareId}&kpin=${input.kpin}`
      );
    } catch (e) {
      setError(e.message);
    }
  };

  const getTitle = (title) => {
    const { orchardName = "", growingSeason = "" } =
      data?.calculatorDetails || "";
    return title !== "Orchard Overview" && title !== "Introduction"
      ? `${title} for ${orchardName} ${growingSeason}`
      : title;
  };

  const deleteSelectedResults = async () => {
    try {
      const { kpin, shareId } = selectedOrchard.input;
      const token = await getUserBearerToken();

      if (!kpin || !shareId) throw new Error("Invalid shareId or kpin");

      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/v2/kpins/${kpin}/shares/${shareId}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          method: "DELETE",
        }
      );
      const { error, success } = await response.json();
      if (error) throw new Error(error);

      if (success) {
        setActionStatus(DELETE_STATUS_SUCCESS);
        loadOrchardDataForUser();
      }
    } catch (e) {
      setError(e.message);
      setActionStatus(DELETE_STATUS_ERROR);
    }

    setActionStatus(DELETE_STATUS_SUCCESS);
    return;
  };

  const getInputStatus = (shareId) => {
    if (!shareId || !orchardData.length) return false;

    const orchardIndex = orchardData.findIndex(
      (orchard) => orchard.input?.shareId === shareId
    );
    return orchardData[orchardIndex]?.result
      ? CALCULATION_STATUS_COMPLETED
      : CALCULATION_STATUS_DRAFT;
  };

  const saveProgressTimer = () => {
    const url = new URL(window.location.href);
    const shareId = url.searchParams.get("shareId");
    const kpin = url.searchParams.get("kpin");

    const orchard = orchardData.find(
      (orchard) =>
        orchard.input?.shareId === shareId && orchard.input?.kpin === kpin
    );

    if (!orchard) {
      const { kpin, orchardName } = data.calculatorDetails;
      if (kpin && orchardName) {
        // saveNewCalculation();
      }
    } else {
      const status = getInputStatus(shareId);
      if (status === CALCULATION_STATUS_COMPLETED) {
        saveExistingCalcuation(false);
      } else {
        saveExistingCalcuation(true);
      }
    }
  };

  const saveExistingCalcuation = async (saveDraft = true) => {
    try {
      const url = new URL(window.location.href);
      const shareId = url.searchParams.get("shareId");
      const kpin = url.searchParams.get("kpin");
      const token = await getUserBearerToken();

      if (!kpin) throw new Error("Save failed - KPIN not found");

      const varietyNames = Object.keys(FINAL_VALUES.varieties);

      const { calculatorDetails, varieties } = data;

      const inputData = {
        calculatorDetails: {
          ...Object.keys(calculatorDetails).reduce((result, key) => {
            let value = calculatorDetails[key];
            if (key.toLowerCase().includes("percentage") && value)
              value = value / 100;
            if (value === "") {
              value = 0;
            }
            return {
              ...result,
              [key]: value,
            };
          }, {}),
          totalArea: calculatorDetails.totalProductiveArea || 0,
          totalKgLeavingOrchard: calculatorDetails.totalKgLeavingOrchard || 0,
          totalClass1Trays: calculatorDetails.totalClass1Trays || 0,
        },
        varieties: varietyNames.reduce((result, varietyName) => {
          return {
            ...result,
            [varietyName]: {
              ...FINAL_VALUES.varieties[varietyName],
              ...Object.keys(varieties[varietyName] || {}).reduce(
                (varietyResult, key) => {
                  let value = varieties[varietyName][key];
                  if (key.toLowerCase().includes("percentage") && value)
                    value = value / 100;
                  if (value === "") value = 0;
                  return {
                    ...varietyResult,
                    [key]: value,
                  };
                },
                {}
              ),
              compostNitrogenPercent:
                calculatorDetails.compostNitrogenPercent / 100,
              compostDryMatter: calculatorDetails.compostDryMatter / 100,
              manureNitrogenPercent:
                calculatorDetails.manureNitrogenPercent / 100,
              manureDryMatter: calculatorDetails.manureDryMatter / 100,
            },
          };
        }, {}),
      };

      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/v2/kpins/${kpin}/shares/${shareId}?saveDraft=${saveDraft}`,
        {
          headers: { Authorization: `Bearer ${token}` },
          method: "PATCH",
          body: JSON.stringify(inputData),
        }
      );

      const results = await response.json();
      if (!results) throw new Error("Save failed");

      if (saveDraft === false) {
        loadOrchardDataForUser();
      }

      SetSaveMessage(
        `Draft last saved  ${new Date().toLocaleDateString()}  ${new Date().toLocaleTimeString()}`
      );
    } catch (e) {
      setError(e.error);
    }
  };

  const saveNewCalculation = async (nextLink) => {
    try {
      const url = new URL(window.location.href);
      const urlShareId = url.searchParams.get("shareId");
      const urlKpin = url.searchParams.get("kpin");

      if (urlShareId || urlKpin) {
        return;
      }

      const token = await getUserBearerToken();
      const { kpin } = data.calculatorDetails;
      const { calculatorDetails, varieties } = data;
      const varietyNames = Object.keys(FINAL_VALUES.varieties);

      if (!kpin) throw new Error("Save failed - KPIN not found");

      const inputData = {
        calculatorDetails: {
          ...Object.keys(calculatorDetails).reduce((result, key) => {
            let value = calculatorDetails[key];
            if (key.toLowerCase().includes("percentage") && value)
              value = value / 100;
            if (value === "") {
              value = 0;
            }
            return {
              ...result,
              [key]: value,
            };
          }, {}),
          totalArea: calculatorDetails.totalProductiveArea || 0,
          totalKgLeavingOrchard: calculatorDetails.totalKgLeavingOrchard || 0,
          totalClass1Trays: calculatorDetails.totalClass1Trays || 0,
        },
        varieties: varietyNames.reduce((result, varietyName) => {
          return {
            ...result,
            [varietyName]: {
              ...FINAL_VALUES.varieties[varietyName],
              ...Object.keys(varieties[varietyName] || {}).reduce(
                (varietyResult, key) => {
                  let value = varieties[varietyName][key];
                  if (key.toLowerCase().includes("percentage") && value)
                    value = value / 100;
                  if (value === "") value = 0;
                  return {
                    ...varietyResult,
                    [key]: value,
                  };
                },
                {}
              ),
              compostNitrogenPercent:
                calculatorDetails.compostNitrogenPercent / 100,
              compostDryMatter: calculatorDetails.compostDryMatter / 100,
              manureNitrogenPercent:
                calculatorDetails.manureNitrogenPercent / 100,
              manureDryMatter: calculatorDetails.manureDryMatter / 100,
            },
          };
        }, {}),
      };

      const response = await fetch(
        `${process.env.REACT_APP_CALC_API_URL}/v2/kpins/${kpin}?saveDraft=true`,
        {
          headers: { Authorization: `Bearer ${token}` },
          method: "POST",
          body: JSON.stringify(inputData),
        }
      );
      const results = await response.json();

      if (!results.shareId) throw new Error(error);

      const updatedInput = {
        ...inputData,
        shareId: results.shareId,
        kpin: results.kpin,
        season: results.season,
        shareToZespri: results.shareToZespri,
      };

      setSessionStorage(INPUT_DATA_KEY, updatedInput);
      setData(updatedInput);

      loadOrchardDataForUser();
      SetSaveMessage(
        `Draft last saved  ${new Date().toLocaleDateString()}  ${new Date().toLocaleTimeString()}`
      );
      navigate(`/production?kpin=${results.kpin}&shareId=${results.shareId}`);

      return;
    } catch (e) {
      setError(e.error);
    }
  };

  return (
    <AppWrapper>
      <PageWrapper>
        <NavBar
          navLinks={getNavLinks()}
          userDetails={userDetails}
          signOut={signOut}
          setShowDisclaimer={setShowDisclaimer}
          pathname={pathname}
        />
        {!loading && (
          <>
            <Routes>
              {["/summary", "/"].map((path) => (
                <Route
                  key={path}
                  path={path}
                  element={
                    <Summary
                      initialiseCalculation={initialiseCalculation}
                      orchardData={orchardData}
                      loading={loading}
                      getResultsData={getResultsData}
                      setModalOpen={setModalOpen}
                      setselectedOrchard={setselectedOrchard}
                      setActionStatus={setActionStatus}
                      resumeDraft={resumeDraft}
                      setClonedKpinName={setClonedKpinName}
                    />
                  }
                />
              ))}
              {VIEWS.map((view, i) => (
                <Route
                  key={view.path}
                  path={view.path}
                  element={
                    <Calculator
                      {...view}
                      title={getTitle(view.title)}
                      setData={setData}
                      data={data}
                    />
                  }
                />
              ))}
              <Route
                path={"results"}
                element={
                  <Results
                    data={data}
                    setEmailModalOpen={setEmailModalOpen}
                    recalculateResults={recalculateResults}
                    getUserBearerToken={getUserBearerToken}
                    setRenewOrchardData={setRenewOrchardData}
                    setRecalculateResults={setRecalculateResults}
                  />
                }
              />
              <Route
                path={"whatif"}
                element={
                  <WhatIf
                    {...WHAT_IF_VIEW}
                    data={data}
                    setData={setData}
                    recalculateResults={recalculateResults}
                    getUserBearerToken={getUserBearerToken}
                  />
                }
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
            <UnavailableViewModal
              path={pathname.replace("/", "")}
              navLinks={getNavLinks()}
            />
            {pathname !== "/summary" && (
              <PageContainer type="dont-print">
                <ButtonWrapper>
                  {prevLink && (
                    <SecondaryButtonLink to={prevLink}
                    onClick={async () => {
                      const url = new URL(window.location.href);

                      if (!NON_SAVING_URLS.includes(url.pathname)) {
                        saveProgressTimer();
                      }
                    }}
                    >
                      {PREV_PAGE_TEXT}
                    </SecondaryButtonLink>
                  )}

                  {nextLink && (
                    <PrimaryButtonLink
                      to={nextLink}
                      onClick={async () => {
                        const url = new URL(window.location.href);

                        if (pathname === "/orchard-overview") {
                          await saveNewCalculation();
                        } else if (!NON_SAVING_URLS.includes(url.pathname)) {
                          saveProgressTimer();
                        }
                      }}
                      disabled={getNextButtonDisabled()}
                    >
                      {getNextButtonText()}
                    </PrimaryButtonLink>
                  )}
                  {showResultsButton && (
                    <PrimaryButtonLink
                      to={`../results${search}`}
                      onClick={() => setViewAsCompleted(pathname)}
                    >
                      {RESULTS_TEXT}
                    </PrimaryButtonLink>
                  )}

                  {pathname === "/results" && search && (
                    <PrimaryButtonLink
                      onClick={window.print}
                      data-testid="print-results-button"
                    >
                      {PRINT_BUTTON_TEXT}
                    </PrimaryButtonLink>
                  )}
                  {pathname === "/results" && (
                    <PrimaryButtonLink
                      to={`../whatif`}
                      onClick={() => setViewAsCompleted(pathname)}
                    >
                      {WHAT_IF_TEXT}
                    </PrimaryButtonLink>
                  )}
                </ButtonWrapper>
              </PageContainer>
            )}
          </>
        )}
      </PageWrapper>

      <SaveMessage
        message={
          pathname !== "/" && pathname !== "/summary" && pathname !== "/results"
            ? saveMessage
            : ""
        }
      />

      <LoadingModal isOpen={loading} />
      <ErrorModal error={error} onClose={() => setError(null)} />
      <EmailLinkModal
        isOpen={emailModalOpen}
        onModalClose={() => setEmailModalOpen(false)}
        savedEmailAddress={data ? data.calculatorDetails.email : ""}
      />
      <SummaryModal
        isOpen={modalOpen}
        onModalClose={() => setModalOpen(false)}
        actionStatus={actionStatus}
        allowClose={allowClose}
        setModalOpen={setModalOpen}
        modalTitle={modalTitle}
        modalContent={modalContent}
      />
    </AppWrapper>
  );
}

export default App;
